module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "search__results"
  }, [_c('div', {
    staticClass: "search__results-container"
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": _vm.query
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search__results-signifier"
  }, [_vm._v("Search Results:")]), _vm._v(" "), _vm._l((_vm.results), function(result) {
    return _c('article', {
      staticClass: "search__result"
    }, [_c('a', {
      staticClass: "search__result-title",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(result.title.rendered))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "search__result-content",
      domProps: {
        "innerHTML": _vm._s(_vm.spliceContent(result.content.rendered))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "search__result-link",
      attrs: {
        "href": result.link
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }), _vm._v(" "), _c('hr', {
      staticClass: "search-result__hr"
    })])
  }), _vm._v(" "), (_vm.postsRemaining) ? _c('button', {
    staticClass: "search-results__load-more",
    domProps: {
      "textContent": _vm._s('Load More')
    },
    on: {
      "click": _vm.getPosts
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchResults) ? _c('div', {
    staticClass: "search__result-none",
    domProps: {
      "textContent": _vm._s('No search results.')
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c3ec8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchResults.vue
// module id = 260
// module chunks = 1